import React from 'react';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { useDeleteAccountMutation } from '../../api/useDeleteAccountMutation';
import { AccountDTO } from '../../../../Profile/Accounts/api/useAccountsQuery';

interface Props {
  clientId: string;
  account: AccountDTO;
  onClose(): void;
  onSuccess(): void;
}

export const DeleteAccountModal = ({ clientId, account, onClose, onSuccess }: Props) => {
  const {
    mutateAsync: deleteAccount,
    isLoading: isDeletingAccount,
    error: deleteAccountError,
  } = useDeleteAccountMutation({ clientId });

  const handleDeleteAccount = async () => {
    try {
      await deleteAccount({ clientId, id: account.AccountId });
      onSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'account-delete--modal-header' }}
    >
      <ModalHeader as="h2" id="account-delete--modal-header">
        Are you sure you want to delete this account?
      </ModalHeader>

      {deleteAccountError && (
        <Alert message={deleteAccountError.message} variant="error" mb="16" mx="24" />
      )}

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="error" isLoading={isDeletingAccount} onClick={handleDeleteAccount} ml="8">
          Delete Account
        </Button>
      </ModalFooter>
    </Modal>
  );
};
